// whatisbff.js
import Download from "./Download";
export default function WhatIsBFF() {
    const steps = [
        {
            badge: "Step 1",
            title: "Share your vibe",
            text: "Tell us your goals, favorite workouts, schedule, age range, and preferences. We’ll use this to help you find people with a similar energy.",
        },
        {
            badge: "Step 2",
            title: "Recruit your FitFriends",
            text: "Scroll through potential matches and send a recruit request to people who match your interests, goals, age, and gender preferences.",
        },
        {
            badge: "Step 3",
            title: "Match & start chatting",
            text: "When you both recruit each other, you officially become FitFriends. Think Juliana + Scarlett finally hitting 'recruit' on each other.",
        },
        {
            badge: "Step 4",
            title: "Connect, meet up, move",
            text: "Use the in-app messaging to plan workouts, runs, gym sessions, or classes together and start showing up for each other IRL.",
        },
    ];

    const groups = [
        {
            title: "Run Clubs",
            text: "Join local run crews so you’re never doing miles alone again.",
        },
        {
            title: "Gym & Studio Squads",
            text: "Find people who lift at your gym or love the same fitness classes.",
        },
        {
            title: "School & Campus Groups",
            text: "Connect with classmates who want to stay active between lectures.",
        },
        {
            title: "Community Meetups",
            text: "Hiking groups, walking crews, intramural teams, and more.",
        },
    ];

    return (
        <>
            {/* HOW IT WORKS */}
            <section id="what-is-bff" className="what-is-bff">
                <div className="container">
                    <div className="what-is-bff-header">
                        <h3>How BeFitFriends Works</h3>
                        <p className="what-is-bff-question">
                            Looking for a fitness friend? Need an accountability partner? Want
                            someone who actually gets your goals?
                        </p>
                        <p className="what-is-bff-subtitle">
                            BeFitFriends helps you turn mutual “we should work out” energy
                            into real-life meetups and movement.
                        </p>
                    </div>

                    <div className="bff-step-grid">
                        {steps.map((step) => (
                            <article key={step.title} className="bff-card">
                                <span className="bff-card-badge">{step.badge}</span>
                                <h4>{step.title}</h4>
                                <p>{step.text}</p>
                            </article>
                        ))}
                    </div>
                </div>
            </section>

            {/* PUBLIC GROUPS SECTION */}
            <section id="bff-groups" className="bff-groups">
                <div className="container">
                    <div className="bff-groups-header">
                        <h3>Not looking for just one FitFriend?</h3>
                        <p>
                            Join public groups instead! Perfect for people who love the
                            atmosphere of a crew.
                        </p>
                    </div>

                    <div className="bff-groups-grid">
                        {groups.map((group) => (
                            <article key={group.title} className="bff-group-card">
                                <h4>{group.title}</h4>
                                <p>{group.text}</p>
                            </article>
                        ))}
                    </div>
                </div>
            </section>


            {/* DOWNLAOD */}
            <section id="what-is-bff" className="what-is-bff">
                <div className="container">
                    <div className="what-is-bff-header">
                        <p className="what-is-bff-question">
                            <Download />
                        </p>
                    </div>

                    
                </div>
            </section>
        </>
    );
}

<Download />